import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import BookingDetailPage from './BookingDetailPage';

export const prefix = 'bm-p-booking-detail';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: BookingDetailPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
